import React, { createContext, useState } from "react";

export const userDetailsContext = createContext();

const UserContextProvider = (props) => {
  const [user, setUser] = useState({
    Salutation: "",
    FirstName: "",
    LastName: "",
    DOB: "",
    Age: "",
    Gender: "",
    EmploymentStatus: "",
    MaritalStatus: "",
    Country: "",
    Nationality: "",
    EmergencyContactType: "",
    EmergencyContactName: "",
    EmergencyContactNumber: "",
    IdType: "",
    IdNumber: "",
    PreferredLanguage: "",
    SpecialAssistance: "",
    BloodGroup: "",
    ReferralSource: "",
    EmailId: "",
    MobileNumber: "",
    Pincode: "",
    State: "",
    City: "",
    Area: "",
    DoorNoAppartmentName: "",
    StreetLocality: "",
  });

  const updateUser = (name) => {
    setUser((prev) => ({ ...prev, ...name }));
  };
  return (
    <div>
      <userDetailsContext.Provider value={{ user, updateUser }}>
        {props.children}
      </userDetailsContext.Provider>
    </div>
  );
};

export default UserContextProvider;
